import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { GrDocumentPdf } from "react-icons/gr";
import { BsReceiptCutoff } from "react-icons/bs";
import api from "../../../services/baseUrl";
import download from "downloadjs";
import Cookies from "js-cookie";

export default function PurchaseHistory() {
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await api.post("/ewarta/purchaseHistory", { userId });

      const sortedData = response.data.sort(
        (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
      );
      setData(sortedData);
    };
    fetchData();
  }, [userId]);

  const downloadPdf = async (requestId) => {
    try {
      const response = await api.post(
        "ewarta/request/get",
        { requestId },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileName = "Lawnet Warta On Demand";

      const contentType = response.headers["content-type"];
      download(response.data, fileName.split("/").pop(), contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const downloadReceipt = async (refNo) => {
    try {
      const response = await api.post(
        "ewarta/request/getReceipt",
        { refNo },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileName = "Warta On Demand Receipt_" + refNo;

      const contentType = response.headers["content-type"];
      download(response.data, fileName.split("/").pop(), contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  return (
    <div className="search-history-container">
      <div className="search-history-announcement">
        Here, you can review your past requests, searches, and interactions with
        gazettes, and easily access any previously viewed or downloaded gazettes
      </div>
      <div className="search-history-searchbox">
        <Search />
      </div>
      <div className="search-history-body">
        <div className="ewarta-search-result-body">
          <table style={{ padding: "25px" }}>
            <thead>
              <tr>
                <td>Purchase Date</td>
                <td>Search Keyword Used</td>
                <td>Quantity (Pages)</td>
                <td>Document</td>
                <td>Receipt</td>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <td>
                    {new Date(
                      item.receipt.dateModified || item.receipt.dateCreated
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </td>
                  <td>{item.gazetteName}</td>
                  <td>{item.pagesQuantity}</td>
                  <td
                    className="clickable"
                    onClick={() => {
                      downloadPdf(item.wartaDocument.id);
                    }}
                  >
                    <GrDocumentPdf size={20} />
                  </td>
                  <td
                    className="clickable"
                    onClick={() => {
                      downloadReceipt(item.refNo);
                    }}
                  >
                    <BsReceiptCutoff size={20} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
